// Third party.
require('./partials/modernizr.js');
var $ = window.jQuery;
require('tiny-slider');

//import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
//Swiper.use([Autoplay, Navigation, Pagination]);

import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/core";
Swiper.use([Navigation, Pagination]);

// require('@fortawesome/fontawesome-free/js/all.js');
//var CountUp = require('countup.js');

// Default functionality for navigation/search etc.
var navigation = require('./sections/navigation.js')($, Modernizr);
var search = require('./sections/search.js')($);

// Default functionality for each section required on the website.
var banner = require('./sections/banner.js')($);
var twocolumn = require('./sections/two-column.js')($, Modernizr);
//var countup = require('./sections/count-up.js')($, CountUp, Modernizr);
var logocarousel = require('./sections/logo-carousel.js')($);
var stickyelements = require('./sections/sticky-elements.js')($);
var accordion = require('./sections/accordion.js')($);

var twentytwenty = require('./sections/twentytwenty.js')($);

$(document).ready(function() {

    /**
     * Custom functionality and overrides.
     */
    
    $( '.tabs .tab .tab-button' ).on( 'click touch', function(e) {
        e.preventDefault();

        if ($(this).parents('.tab').hasClass( 'active' ) ) {
          $(".tabs .tab").removeClass("active");
          $(".tabs .tab-content").hide();
        } else {
          $(".tabs .tab").removeClass("active");
          $( this ).parents( '.tab' ).addClass( 'active' );
          var target = $( this ).attr( 'href' );
          var targetMob = $(this).data("mobile");
          $(".tabs .tab-content").hide();
          $( target ).show(300);
          $( targetMob ).show(300);
          $( '.tab-image-before' ).addClass( 'opacity', 0 );
          setTimeout(
              function(){
                  $( '.tab-image-before' ).addClass( 'opacity', 1 );
                  $( '.tab-image-before' ).twentytwenty({
                      'no_overlay': true
                  });   
              }, 
              300
          );
        }
    });

    $(".before-after-image").twentytwenty({
      no_overlay: true,
    }); 

    $(".tabs-side .tab").on("click touch", function (e) {
      e.preventDefault();
      $(".tabs-side .tab").removeClass("active");
      $(this).addClass("active");
      var target = $(this).find(".button").attr("href");
      var targetMob = $(this).find(".button").data("mobile");
      
      $(".tabs-side .tab-content").hide();
      $(target).show(300);
      $(targetMob).show(300);
    });


    const swiperGallery = new Swiper(".gallery .swiper-container", {
      loop: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1.4,
      spaceBetween: 0,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 2.4,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });

    const swiperProducts = new Swiper(".products .swiper-container", {
      loop: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        992: {
          slidesPerView: 1.7,
        },
      },
      pagination: {
        el: ".products .swiper-pagination",
        type: "bullets",
        clickable: true
      },
    });

    const swiperBlog = new Swiper(".blog .swiper-container", {
      loop: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".blog .swiper-pagination",
        type: "bullets",
        clickable: true
      },
    });

    const swiperLogos = new Swiper(".logo-carousel .swiper-container", {
      loop: true,
      autoplay: {
        delay: 2500,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 2,
      spaceBetween: 30,
      breakpoints: {
        992: {
          slidesPerView: 4,
        },
      }
    });

    const swiperFact = new Swiper(".facts .swiper-container", {
      loop: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".facts swiper-pagination",
        type: "bullets",
        clickable: true
      },
    });

    const swiperSplit = new Swiper(".split-slider .swiper-container", {
      loop: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".split-slider .swiper-pagination",
        type: "bullets",
        clickable: true
      },
    });
    

    $(".video-link").on( 'click touch', function(e) {
      e.preventDefault();
      $(this).find("iframe")[0].src += "?autoplay=1";
      $(this).find(".play-video-container").show();
      $(this).find('.play').hide();
      $(this).find('.caption').hide();
      $(this).find(".placeholder").hide();
    })

    $(".popup-modal").magnificPopup({
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false,
    });

    $(".popup-image").magnificPopup({
      type: "image",
      closeOnContentClick: true,
      image: {
        verticalFit: false,
      },
    });


});
